import { forwardRef, SyntheticEvent, useImperativeHandle, useState } from 'react'
import { Box, BoxProps, Container, Grid, Tab, Tabs, Typography } from '@mui/material'

export type TabsHeadingProps = BoxProps &
  Partial<{
    title: string
    text: string
    tabs: {
      label: string
    }[]
    is_first: boolean
    // eslint-disable-next-line no-unused-vars
    onTabChange?: (index: number) => void
  }>

const TabsHeading = forwardRef(
  ({ title, text, tabs, onTabChange, is_first, ...props }: TabsHeadingProps, ref) => {
    const [value, setValue] = useState(0)

    const handleChange = (event: SyntheticEvent, newValue: number) => {
      setValue(newValue)
      onTabChange?.(newValue)
    }

    /*------------------------------
  Espongo handleChange per poter essere usato esternamente
  ------------------------------*/
    useImperativeHandle(ref, () => ({
      setTab: (index: number) => {
        setValue(index)
      },
      value: value
    }))

    return (
      <Box {...props} ref={ref}>
        <Container>
          <Grid container>
            <Grid
              size={{ xs: 4, sm: 6 }}
              offset={{ sm: 1, md: 3 }}
              sx={{ display: 'grid', gap: 2 }}
            >
              {title ? (
                <Typography
                  variant="h4"
                  color="text.secondaryContrastText"
                  component={is_first ? 'h1' : 'h2'}
                >
                  {title}
                </Typography>
              ) : null}

              {text ? (
                <Typography variant="textRegular" color="text.primary" component="p">
                  {text}
                </Typography>
              ) : null}
            </Grid>

            {tabs?.length ? (
              <Grid
                size={{ xs: 4, sm: 8, md: 12 }}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <Tabs value={value} onChange={handleChange} aria-label="tabs heading">
                  {tabs.map(({ label }, index) => (
                    <Tab key={`item-${index}`} label={label} />
                  ))}
                </Tabs>
              </Grid>
            ) : null}
          </Grid>
        </Container>
      </Box>
    )
  }
)

export default TabsHeading
